import { useCallback, useRef, useState } from 'react'
import { LuClipboardCheck, LuClipboardCopy } from 'react-icons/lu'

interface CopyButtonProps {
  getText: () => string
  className?: string
  size?: number
}

export const CopyButton = ({ getText, className, size = 16 }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      navigator.clipboard.writeText(getText())
      setCopied(true)
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setCopied(false), 2000)
    },
    [getText],
  )

  return (
    <button className={className} onClick={handleClick} data-testid="copy-button">
      {copied ? <LuClipboardCheck size={size} /> : <LuClipboardCopy size={size} />}
    </button>
  )
}
